<!-- Supervisão: "Por atribuir" (Clientes), depois um bloco por consultor, 10 de cada vez -->
<div class="chat-sup">
  <!-- skeleton: só enquanto a primeira página não chegou -->
  <div *ngIf="loading && groups.length === 0" class="chat-sup__skeleton" role="status" [attr.aria-label]="strings.loading">
    <div *ngFor="let w of skeletonRows" class="chat-sup__sk-row" aria-hidden="true">
      <span class="chat-sup__sk chat-sup__sk--avatar"></span>
      <span class="chat-sup__sk-lines">
        <span class="chat-sup__sk chat-sup__sk--line" [style.width.%]="w"></span>
        <span class="chat-sup__sk chat-sup__sk--line chat-sup__sk--thin"></span>
      </span>
    </div>
  </div>

  <!-- Por atribuir -->
  <section *ngIf="showQueue" class="chat-group chat-group--queue">
    <button type="button" class="chat-group__head" [attr.aria-expanded]="queueOpen" (click)="toggleQueue()">
      <span class="chat-group__icon"><chat-icon name="clock" [size]="16"></chat-icon></span>
      <span class="chat-group__text">
        <span class="chat-group__name">{{ strings.tabQueue }}</span>
        <span class="chat-group__sum chat-group__sum--waiting">{{ queueSummary() }}</span>
      </span>
      <span class="chat-group__count">{{ queue.length }}</span>
      <span class="chat-group__chev" [class.chat-group__chev--closed]="!queueOpen" aria-hidden="true"></span>
    </button>
    <ng-container *ngIf="queueOpen">
      <chat-conversation-item *ngFor="let c of visibleQueue; trackBy: trackByKey" [conversation]="c" [queue]="true" [supervision]="true"
        [presence]="presenceOf(c)" [active]="keyOf(c) === activeKey" [strings]="strings"
        (select)="select.emit($event)"></chat-conversation-item>
      <button *ngIf="queue.length > visibleQueue.length" type="button" class="chat-sup__more" (click)="moreQueue()">{{ strings.showMoreConversations }}</button>
    </ng-container>
  </section>

  <!-- um bloco por consultor, fechado -->
  <section *ngFor="let g of groups; trackBy: trackByGroup" class="chat-group">
    <button type="button" class="chat-group__head" [attr.aria-expanded]="g.open" (click)="toggle(g)">
      <chat-avatar *ngIf="g.userAppId" [src]="g.photo" [name]="g.name" [size]="32" [status]="presenceOfId(g.userAppId)"></chat-avatar>
      <span *ngIf="!g.userAppId" class="chat-group__icon chat-group__icon--none"><chat-icon name="users" [size]="16"></chat-icon></span>
      <span class="chat-group__text">
        <span class="chat-group__name">{{ g.name }}</span>
        <span class="chat-group__sum" [class.chat-group__sum--waiting]="kind === 'clients' && g.waiting > 0">{{ summary(g) }}</span>
      </span>
      <span *ngIf="g.loadingRows && !g.loaded" class="chat-sup__spinner" aria-hidden="true"></span>
      <span class="chat-group__chev" [class.chat-group__chev--closed]="!g.open" aria-hidden="true"></span>
    </button>
    <ng-container *ngIf="g.open">
      <chat-conversation-item *ngFor="let c of g.rows; trackBy: trackByKey" [conversation]="c" [supervision]="true"
        [presence]="presenceOf(c)" [active]="keyOf(c) === activeKey" [strings]="strings"
        (select)="select.emit($event)"></chat-conversation-item>
      <button *ngIf="g.failedRows" type="button" class="chat-sup__more" (click)="moreRows(g)">{{ strings.supervisionRetry }}</button>
      <button *ngIf="!g.failedRows && hasMoreRows(g)" type="button" class="chat-sup__more" [disabled]="g.loadingRows" (click)="moreRows(g)">
        {{ g.loadingRows ? strings.loading : strings.showMoreConversations }}
      </button>
    </ng-container>
  </section>

  <!-- fim da lista: mais consultores ao aparecer (ou no botão) -->
  <div *ngIf="hasMore" class="chat-sup__end">
    <div #sentinel class="chat-sup__sentinel" aria-hidden="true"></div>
    <button type="button" class="chat-sup__more" [disabled]="loadingMore" (click)="loadMore()">
      {{ loadingMore ? strings.loading : strings.loadMoreConsultants }}
    </button>
  </div>

  <div *ngIf="failed" class="chat-sup__empty">
    <chat-empty-state icon="users" [title]="strings.supervisionFailed" text="" [actionLabel]="strings.supervisionRetry"
      (action)="retry()"></chat-empty-state>
  </div>

  <div *ngIf="isEmpty" class="chat-sup__empty">
    <chat-empty-state *ngIf="search" icon="search" [title]="strings.emptySearchTitle" text=""></chat-empty-state>
    <ng-container *ngIf="!search">
      <ng-container *ngIf="kind === 'clients'">
        <chat-empty-state *ngIf="filter === 'all'" icon="users" [title]="strings.emptyTeamTitle" [text]="strings.emptyTeamText"></chat-empty-state>
        <chat-empty-state *ngIf="filter === 'waiting'" icon="check2" [title]="strings.emptyWaitingTitle" [text]="strings.emptyWaitingText"></chat-empty-state>
      </ng-container>
      <chat-empty-state *ngIf="kind === 'staff'" icon="chat" [title]="strings.emptySupervisionStaffTitle" [text]="strings.emptySupervisionStaffText"></chat-empty-state>
    </ng-container>
  </div>
</div>
